import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  countPlayer: 0,
  affReport: {},
  selectedMonth: 6,
  loading: false,
  loadingBar: false,
  defaultSelectedMonth: {
    title: "month.jun",
    value: 6
  },
  barChartData : [],
  barValue : 0

};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
